import Http from '../Http';
import {
  addVersion,
} from '../HelperAPI';

const baseUrl = `${process.env.VAPI_BASE_URL}/loops`;

export default {
  list: async (data, options) => {
    options = addVersion('8.31.0', options);
    const response = await Http.post(`${baseUrl}/search`, data, options) || {};

    if (response.data) {
      for (let i = 0; i < response.data.length; i++) {
        const loop = response.data[i];

        if (loop.messages) {
          for (let y = 0; y < loop.messages.length; y++) {
            const message = loop.messages[y];
            if (message.media) {
              for (let j = 0; j < message.media.length; j++) {
                message.media[j].url = Http.cloudfront(message.media[j].url);
              }
            }
          }
        }
      }
    }

    return response;
  },
  getById: async (id, options = {}) => {
    const response = await Http.get(`${baseUrl}/${id}`, options) || {};

    return {
      ...response,
      messages: response.messages.map(message => {
        return {
          ...message,
          media: message.media.map(mediaItem => {
            mediaItem.url = Http.cloudfront(mediaItem.url);
            return mediaItem;
          }),
        };
      }),
    };
  },
  create: (data, options = {}) => {
    return Http.post(baseUrl, data, options);
  },
  modify: (id, data, options = {}) => {
    return Http.put(`${baseUrl}/${id}`, data, options);
  },
  getExpandedLocations: async (id, options) => {
    const response = await Http.get(`${baseUrl}/${id}/locations/expanded`, options) ?? [];

    return response.map(item => {
      const locations = item.locations ?? [];

      return {
        ...item,
        imageUrl: Http.cloudfront(item.imageUrl),
        locations: locations.map(location => {
          return {
            ...location,
            imageUrl: Http.cloudfront(location.imageUrl),
          };
        }),
      };
    });
  },
  reactivate: (data, options) => {
    return Http.post(`${baseUrl}/${data._id}`, data, options);
  },
  deactivate: id => Http.delete(`${baseUrl}/${id}`),
  deactivateBulk: (loops) => Http.delete(baseUrl, {
    loops,
  }),
};
